import { render, staticRenderFns } from "./ChatPicture.vue?vue&type=template&id=7cf941d0"
import script from "./ChatPicture.vue?vue&type=script&lang=js"
export * from "./ChatPicture.vue?vue&type=script&lang=js"
import style0 from "./ChatPicture.vue?vue&type=style&index=0&id=7cf941d0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports